import { Injectable, signal } from '@angular/core';
import { ExternalCall } from '../models/external-call.model';
import {HttpClient} from '@angular/common/http';
import {PercentageAndAmountStat} from './models/PercentageAndAmountStat';
import {searchUrl} from './defines';

@Injectable({ providedIn: 'root' })
export class ExternalCallService {
  private calls = signal<ExternalCall[]>(this.generateInitialMockCalls());

  constructor(private _httpClient: HttpClient) {
  }
  getCalls = this.calls.asReadonly();


  getAll() {
    return this._httpClient.get<any>(`${searchUrl}/external-calls`)
  }
  retryCall(id: string): void {
    this.calls.update(items =>
      items.map(item => {
        if (item.id === id) {
          const randomSuccess = Math.random() > 0.15;
          return {
            ...item,
            status: randomSuccess ? 'SUCCESS' : 'FAILED',
            httpStatus: randomSuccess ? (item.type === 'SMS' ? 201 : 200) : 504,
            durationMs: Math.floor(Math.random() * 300) + 80,
            timestamp: new Date().toISOString(),
            errorMessage: randomSuccess ? undefined : 'Gateway timeout during retry'
          };
        }
        return item;
      })
    );
  }

  simulateLiveCall(type: 'PAYMENT' | 'SMS' | 'GPS' | 'MAPS' | 'VERIFICATION' | 'EMAIL'): void {
    const freshCall = this.createSingleSimulatedCall(type);
    this.calls.update(items => [freshCall, ...items]);
  }

  clearLogs(): void {
    this.calls.set([]);
  }

  resetLogs(): void {
    this.calls.set(this.generateInitialMockCalls());
  }

  private createSingleSimulatedCall(type: 'PAYMENT' | 'SMS' | 'GPS' | 'MAPS' | 'VERIFICATION' | 'EMAIL'): ExternalCall {
    const id = `EXT-${Math.floor(Math.random() * 90000) + 10000}`;
    const timestamp = new Date().toISOString();
    const durationMs = Math.floor(Math.random() * 1200) + 50;
    const isSuccess = Math.random() > 0.12;

    switch (type) {
      case 'PAYMENT': {
        const amount = Math.floor(Math.random() * 5000) + 500;
        const gate = Math.random() > 0.5 ? 'Wave' : 'Orange Money';
        const affectedId = `SAL-${Math.floor(Math.random() * 1000) + 2000}`;
        return {
          id,
          serviceName: `${gate} Core Portal`,
          type: 'PAYMENT',
          httpMethod: 'POST',
          route: gate === 'Wave' ? 'https://api.wave.com/v1/checkout/payments' : 'https://api.orange.sn/om/v2/transactions',
          requestHeader: { 'Authorization': 'Bearer wv_live_sec_8fb92da...', 'Content-Type': 'application/json' },
          requestPayload: JSON.stringify({ amount, currency: 'XOF', order_id: `ORD-${id}`, callback_url: 'https://ais-pre-weh3v.run.app/api/payments/callback' }, null, 2),
          responseHeader: { 'Content-Type': 'application/json', 'Server': 'nginx' },
          responsePayload: isSuccess
            ? JSON.stringify({ id: `wv_txn_${id}`, status: 'completed', amount, created_at: timestamp }, null, 2)
            : JSON.stringify({ error: 'insufficient_funds', message: 'The customer account has insufficient balance.' }, null, 2),
          timestamp,
          durationMs,
          status: isSuccess ? 'SUCCESS' : 'FAILED',
          httpStatus: isSuccess ? 200 : 402,
          errorMessage: isSuccess ? undefined : 'Insufficient customer funds (HTTP 402)',
          provider: "test",
          calledAt: new Date(),
          affectedEntity: {
            type: 'Sale',
            id: affectedId,
            label: `Sale Ref: ${affectedId}`
          }
        };
      }
      case 'SMS': {
        const phone = `+221 77 ${Math.floor(Math.random() * 9000000) + 1000000}`;
        const service = 'Orange SMS Gateway';
        const affectedId = `PAS-${Math.floor(Math.random() * 800) + 3000}`;
        return {
          id,
          provider: "test",
          calledAt: new Date(),
          serviceName: service,
          type: 'SMS',
          httpMethod: 'POST',
          route: 'https://api.orange.sn/smsmessaging/v1/outbound/tel/requests',
          requestHeader: { 'Authorization': 'Bearer sms_tok_9273f...', 'Content-Type': 'application/json' },
          requestPayload: JSON.stringify({ outboundSMSMessageRequest: { address: `tel:${phone}`, senderAddress: 'tel:+221000', outboundSMSTextMessage: { message: 'Your booking has been successfully confirmed. Have a nice trip with Dakar Express!' } } }, null, 2),
          responseHeader: { 'Content-Type': 'application/json' },
          responsePayload: isSuccess
            ? JSON.stringify({ resourceURL: `https://api.orange.sn/smsmessaging/v1/outbound/tel/requests/${id}`, deliveryStatus: 'DeliveredToNetwork' }, null, 2)
            : JSON.stringify({ code: 'SMS-901', message: 'Rate limit exceeded for outbound shortcodes' }, null, 2),
          timestamp,
          durationMs,
          status: isSuccess ? 'SUCCESS' : 'FAILED',
          httpStatus: isSuccess ? 201 : 429,
          errorMessage: isSuccess ? undefined : 'Rate limit exceeded (HTTP 429)',
          affectedEntity: {
            type: 'Passenger',
            id: affectedId,
            label: `Passenger: ${phone}`
          }
        };
      }
      // case 'GPS': {
      //   const busRef = `BUS-${Math.floor(Math.random() * 50) + 100}`;
      //   return {
      //     id,
      //     provider: "test",
      //     calledAt: new Date(),
      //     serviceName: 'Core GPS Fleet API',
      //     type: 'GPS',
      //     httpMethod: 'GET',
      //     route: `https://gps-fleet.tracking-systems.com/api/v4/devices/${busRef}/position`,
      //     requestHeader: { 'X-API-Key': 'gps_sec_9fcc...' },
      //     requestPayload: '{}',
      //     responseHeader: { 'Content-Type': 'application/json' },
      //     responsePayload: isSuccess
      //       ? JSON.stringify({ device_id: busRef, latitude: 14.6937 + (Math.random() - 0.5) * 0.1, longitude: -17.4441 + (Math.random() - 0.5) * 0.1, speed_kmh: Math.floor(Math.random() * 80) + 10, heading: Math.floor(Math.random() * 360), battery_level: 98, last_update: timestamp }, null, 2)
      //       : JSON.stringify({ error: 'DeviceOffline', message: 'Tracking unit has no GPRS satellite link active.' }, null, 2),
      //     timestamp,
      //     durationMs,
      //     status: isSuccess ? 'SUCCESS' : 'FAILED',
      //     httpStatus: isSuccess ? 200 : 504,
      //     errorMessage: isSuccess ? undefined : 'Device unreachable / Gateway Timeout (HTTP 504)',
      //     affectedEntity: {
      //       type: 'Bus',
      //       id: busRef,
      //       label: `Bus Ref: ${busRef}`
      //     }
      //   };
      // }
      // case 'MAPS': {
      //   const trajectId = `TRAJ-${Math.floor(Math.random() * 100) + 100}`;
      //   return {
      //     id,
      //     provider: "test",
      //     calledAt: new Date(),
      //     serviceName: 'Google Maps Routes Partner API',
      //     type: 'MAPS',
      //     httpMethod: 'POST',
      //     route: 'https://routes.googleapis.com/v2:computeRoutes',
      //     requestHeader: { 'X-Goog-Api-Key': 'AIzaSyC...', 'Content-Type': 'application/json' },
      //     requestPayload: JSON.stringify({ origin: { address: 'Dakar, Senegal' }, destination: { address: 'Saint-Louis, Senegal' }, travelMode: 'DRIVE', routingPreference: 'TRAFFIC_AWARE' }, null, 2),
      //     responseHeader: { 'Content-Type': 'application/json' },
      //     responsePayload: isSuccess
      //       ? JSON.stringify({ routes: [{ distanceMeters: 265000, duration: '14400s', staticDuration: '13800s', polyline: { encodedPolyline: 'a~|gH~jbQDg@_c...' } }] }, null, 2)
      //       : JSON.stringify({ error: { code: 403, message: 'Google Maps Project Bill-to Account suspended/over limit.', status: 'PERMISSION_DENIED' } }, null, 2),
      //     timestamp,
      //     durationMs,
      //     status: isSuccess ? 'SUCCESS' : 'FAILED',
      //     httpStatus: isSuccess ? 200 : 403,
      //     errorMessage: isSuccess ? undefined : 'API key over quota/billing suspension (HTTP 403)',
      //     affectedEntity: {
      //       type: 'Traject',
      //       id: trajectId,
      //       label: `Traject: ${trajectId}`
      //     }
      //   };
      // }
      case 'VERIFICATION': {
        const idNum = Math.floor(Math.random() * 1000000) + 1000000;
        const employeeId = `EMP-${Math.floor(Math.random() * 200) + 4000}`;
        return {
          id,
          provider: "test",
          calledAt: new Date(),
          serviceName: 'National Driver Registry System',
          type: 'VERIFICATION',
          httpMethod: 'POST',
          route: 'https://registry.government.sn/api/license/verify',
          requestHeader: { 'Content-Type': 'application/json' },
          requestPayload: JSON.stringify({ national_id: `1890199401${idNum}`, license_category: 'C' }, null, 2),
          responseHeader: { 'Content-Type': 'application/json' },
          responsePayload: isSuccess
            ? JSON.stringify({ verified: true, identity_match: true, issue_date: '2019-04-12', expiry_date: '2029-04-12', restrictions: 'NONE' }, null, 2)
            : JSON.stringify({ error: 'DatabaseUnreachable', message: 'Primary voter registry replica database of the interior is offline' }, null, 2),
          timestamp,
          durationMs,
          status: isSuccess ? 'SUCCESS' : 'FAILED',
          httpStatus: isSuccess ? 200 : 500,
          errorMessage: isSuccess ? undefined : 'Remote server internal error (HTTP 500)',
          affectedEntity: {
            type: 'Employee',
            id: employeeId,
            label: `Employee: ${employeeId}`
          }
        };
      }
      default: {
        return {
          id,
          provider: "test",
          calledAt: new Date(),
          serviceName: 'Sendgrid Mail Service',
          type: 'EMAIL',
          httpMethod: 'POST',
          route: 'https://api.sendgrid.com/v3/mail/send',
          requestHeader: { 'Authorization': 'Bearer SG.83jf...', 'Content-Type': 'application/json' },
          requestPayload: JSON.stringify({ personalizations: [{ to: [{ email: 'papemarthiam@gmail.com' }], subject: 'Monthly Financial Audit Reports Summary' }], from: { email: 'no-reply@dakar-express.sn' }, content: [{ type: 'text/html', value: '<h4>Dakar Express Operations Backoffice</h4><p>Attached is the system financial logs.</p>' }] }, null, 2),
          responseHeader: { 'X-Message-ID': `msg_${id}` },
          responsePayload: isSuccess ? '{"status": "queued"}' : '{"error": "Unauthorized endpoint range"}',
          timestamp,
          durationMs,
          status: isSuccess ? 'SUCCESS' : 'FAILED',
          httpStatus: isSuccess ? 202 : 401,
          errorMessage: isSuccess ? undefined : 'Unauthorized API scope (HTTP 401)'
        };
      }
    }
  }

  private generateInitialMockCalls(): ExternalCall[] {
    const categories: ('PAYMENT' | 'SMS' | 'GPS' | 'MAPS' | 'VERIFICATION' | 'EMAIL')[] = [
      'PAYMENT', 'SMS', 'GPS', 'MAPS', 'VERIFICATION', 'EMAIL',
      'PAYMENT', 'SMS', 'GPS', 'SMS', 'PAYMENT', 'VERIFICATION'
    ];

    const list: ExternalCall[] = [];
    const now = Date.now();
    for (let i = 0; i < categories.length; i++) {
      const call = this.createSingleSimulatedCall(categories[i]);
      const minutesAgo = (i + 1) * 12 + Math.floor(Math.random() * 8);
      call.timestamp = new Date(now - minutesAgo * 60 * 1000).toISOString();
      list.push(call);
    }
    return list;
  }
}
